import { render, staticRenderFns } from "./confirm-apply-user.vue?vue&type=template&id=63a8e3de&scoped=true&"
import script from "./confirm-apply-user.vue?vue&type=script&lang=js&"
export * from "./confirm-apply-user.vue?vue&type=script&lang=js&"
import style0 from "./confirm-apply-user.vue?vue&type=style&index=0&id=63a8e3de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8e3de",
  null
  
)

export default component.exports